import { render, staticRenderFns } from "./CourseVideoUploader.vue?vue&type=template&id=25e0ee53&scoped=true"
import script from "./CourseVideoUploader.vue?vue&type=script&lang=js"
export * from "./CourseVideoUploader.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoUploader.vue?vue&type=style&index=0&id=25e0ee53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../edeone/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0ee53",
  null
  
)

export default component.exports